 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AmCharts":"AmCharts","HighCharts":"HighCharts","MorrisCharts":"MorrisCharts","ApexChart":"ApexChart","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"AmCharts":"87010e9d","HighCharts":"868ca4ba","MorrisCharts":"de461aef","chunk-00f2860a":"a9fe14d6","chunk-0716e906":"4094a949","chunk-1c4227e0":"95bd620d","chunk-1cbc01e7":"f97fbb2b","chunk-2028891c":"50603635","chunk-2056826c":"803ab2d5","chunk-2635dfef":"83c8573c","chunk-2d0a4c18":"1e457d96","chunk-2d0b3dcd":"31ef5605","chunk-2d0b65d5":"3218f6c7","chunk-2d0b6ecb":"afedeb5e","chunk-2d0b8e0a":"7a49ecfb","chunk-2d0c4df8":"a5c87652","chunk-2d0c5368":"f8405993","chunk-2d0c7b81":"baf53667","chunk-2d0c7cfe":"4e8ec030","chunk-2d0c7d22":"d3354d2b","chunk-2d0c7f2b":"7c1fa043","chunk-2d0c7f2c":"cc3159fa","chunk-2d0c840a":"9512ef61","chunk-2d0c9a8c":"d169029c","chunk-2d0cbad6":"3860f193","chunk-2d0cbe59":"c1d5313a","chunk-2d0d36a6":"f8bd87af","chunk-2d0da2e7":"bab18099","chunk-2d0db498":"b8dc71e8","chunk-2d0ddf74":"059ebbd5","chunk-2d0e2123":"78f7fbc9","chunk-2d0e268c":"1e5d134d","chunk-2d0e57c1":"c7534c8f","chunk-2d0e5fc1":"3d3bb2e3","chunk-2d0e6514":"be55dfe0","chunk-2d0f0271":"046309b1","chunk-2d208c0e":"c0148aab","chunk-2d213023":"eedb5143","chunk-2d216798":"e0c34c62","chunk-2d2172c6":"f2667dbb","chunk-2d21843f":"99cacd9b","chunk-2d219fca":"ae30502b","chunk-2d21d104":"de0a2bfd","chunk-2d21d6b1":"20889a99","chunk-2d226159":"b3b51e72","chunk-2d2268fd":"1d3fe0d8","chunk-2d228c17":"6084804c","chunk-2d22d215":"f9704d57","chunk-2d230887":"929affc7","chunk-2d2374f7":"9a114617","chunk-2d238257":"6a97cc3a","chunk-2fe774ba":"f3fa6f19","chunk-31409bb6":"e14901aa","chunk-339ae671":"8fa72437","chunk-37e88538":"95e0691c","chunk-4cffd750":"9127b22d","chunk-552dcdc0":"1cda4c16","chunk-7bd73b2d":"ba82fdac","chunk-eafd665a":"6453cdf2","chunk-5aedc4f0":"b31dffff","chunk-62c4d3e6":"b802c622","chunk-62fe045e":"a8a990d7","chunk-78b78f06":"aa47f7b4","chunk-8018c87e":"acb2ef66","chunk-87ff6eda":"248c767d","chunk-8829adea":"99f4ee8a","chunk-882b9da2":"ff6c946c","chunk-8839cc58":"889f629e","chunk-9dc17b5a":"b543dda8","chunk-ab5982ac":"f71db4c7","chunk-b935bd5e":"59981ff4","chunk-1f6cf1f6":"3191798d","chunk-67d4bbbf":"a27f482f","chunk-e6479416":"e8247196","chunk-c490784c":"22db088e","ApexChart":"e5ef10b4","chunk-2d238246":"e5cf6604","chunk-c8eacff0":"40ebdef1","chunk-ca47c236":"bdd56ca5","chunk-f7051d1e":"d5312388","canvg":"7bb1e8e6","pdfmake":"ba5659be","xlsx":"3ac16859","chunk-77223c5a":"54251c32"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-00f2860a":1,"chunk-2fe774ba":1,"chunk-eafd665a":1,"chunk-9dc17b5a":1,"chunk-ab5982ac":1,"chunk-b935bd5e":1,"chunk-1f6cf1f6":1,"chunk-67d4bbbf":1,"chunk-e6479416":1,"chunk-f7051d1e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AmCharts":"AmCharts","HighCharts":"HighCharts","MorrisCharts":"MorrisCharts","ApexChart":"ApexChart","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"AmCharts":"31d6cfe0","HighCharts":"31d6cfe0","MorrisCharts":"31d6cfe0","chunk-00f2860a":"b1c8c08c","chunk-0716e906":"31d6cfe0","chunk-1c4227e0":"31d6cfe0","chunk-1cbc01e7":"31d6cfe0","chunk-2028891c":"31d6cfe0","chunk-2056826c":"31d6cfe0","chunk-2635dfef":"31d6cfe0","chunk-2d0a4c18":"31d6cfe0","chunk-2d0b3dcd":"31d6cfe0","chunk-2d0b65d5":"31d6cfe0","chunk-2d0b6ecb":"31d6cfe0","chunk-2d0b8e0a":"31d6cfe0","chunk-2d0c4df8":"31d6cfe0","chunk-2d0c5368":"31d6cfe0","chunk-2d0c7b81":"31d6cfe0","chunk-2d0c7cfe":"31d6cfe0","chunk-2d0c7d22":"31d6cfe0","chunk-2d0c7f2b":"31d6cfe0","chunk-2d0c7f2c":"31d6cfe0","chunk-2d0c840a":"31d6cfe0","chunk-2d0c9a8c":"31d6cfe0","chunk-2d0cbad6":"31d6cfe0","chunk-2d0cbe59":"31d6cfe0","chunk-2d0d36a6":"31d6cfe0","chunk-2d0da2e7":"31d6cfe0","chunk-2d0db498":"31d6cfe0","chunk-2d0ddf74":"31d6cfe0","chunk-2d0e2123":"31d6cfe0","chunk-2d0e268c":"31d6cfe0","chunk-2d0e57c1":"31d6cfe0","chunk-2d0e5fc1":"31d6cfe0","chunk-2d0e6514":"31d6cfe0","chunk-2d0f0271":"31d6cfe0","chunk-2d208c0e":"31d6cfe0","chunk-2d213023":"31d6cfe0","chunk-2d216798":"31d6cfe0","chunk-2d2172c6":"31d6cfe0","chunk-2d21843f":"31d6cfe0","chunk-2d219fca":"31d6cfe0","chunk-2d21d104":"31d6cfe0","chunk-2d21d6b1":"31d6cfe0","chunk-2d226159":"31d6cfe0","chunk-2d2268fd":"31d6cfe0","chunk-2d228c17":"31d6cfe0","chunk-2d22d215":"31d6cfe0","chunk-2d230887":"31d6cfe0","chunk-2d2374f7":"31d6cfe0","chunk-2d238257":"31d6cfe0","chunk-2fe774ba":"e059b788","chunk-31409bb6":"31d6cfe0","chunk-339ae671":"31d6cfe0","chunk-37e88538":"31d6cfe0","chunk-4cffd750":"31d6cfe0","chunk-552dcdc0":"31d6cfe0","chunk-7bd73b2d":"31d6cfe0","chunk-eafd665a":"68eb27a6","chunk-5aedc4f0":"31d6cfe0","chunk-62c4d3e6":"31d6cfe0","chunk-62fe045e":"31d6cfe0","chunk-78b78f06":"31d6cfe0","chunk-8018c87e":"31d6cfe0","chunk-87ff6eda":"31d6cfe0","chunk-8829adea":"31d6cfe0","chunk-882b9da2":"31d6cfe0","chunk-8839cc58":"31d6cfe0","chunk-9dc17b5a":"374a13c2","chunk-ab5982ac":"d601a5af","chunk-b935bd5e":"fbd602ca","chunk-1f6cf1f6":"0b323f38","chunk-67d4bbbf":"d153a058","chunk-e6479416":"f3392bf8","chunk-c490784c":"31d6cfe0","ApexChart":"31d6cfe0","chunk-2d238246":"31d6cfe0","chunk-c8eacff0":"31d6cfe0","chunk-ca47c236":"31d6cfe0","chunk-f7051d1e":"3e7622d9","canvg":"31d6cfe0","pdfmake":"31d6cfe0","xlsx":"31d6cfe0","chunk-77223c5a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-c490784c","ApexChart","AmCharts","HighCharts","MorrisCharts"]]);
 	return startupResult;
